/**
 * @generated SignedSource<<f57cadb8256214768facef58ef49ce2d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemInternalContext_nftAuctionBidderRef$data = {
  readonly auction: {
    readonly endDate: string | null;
  } | null;
  readonly bidAmount: {
    readonly ether: string | null;
  } | null;
  readonly bidDate: string | null;
  readonly bidderAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "ItemInternalContext_nftAuctionBidderRef";
};
export type ItemInternalContext_nftAuctionBidderRef$key = {
  readonly " $data"?: ItemInternalContext_nftAuctionBidderRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemInternalContext_nftAuctionBidderRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemInternalContext_nftAuctionBidderRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bidDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherAmount",
      "kind": "LinkedField",
      "name": "bidAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ether",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "bidderAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "auction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftAuctionBidderRef",
  "abstractKey": null
};

(node as any).hash = "8a56b97c873f5b56405c3f90b4fcff9a";

export default node;
